import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

const specialTreatments = [
    "Decolantarea foliei sau îndepărtarea stickerelor, literelor colant și reclamelor",
    "Tratamente de decalcifiere și îndepărtare a depunerilor naturale",
    "Curățarea materialelor aderente: ciment, tencuială decorativă, vopsea și spumă",
    "Îndepărtarea și curățarea foliei lichide aplicate sau a foliei originale de protecție",
    "Tratamente speciale aplicate suprafețelor din sticlă deteriorate sau zgâriate",
    "Tratamente hidrofobe pentru pereți din sticlă, cabine de duș, ferestre și terase din sticlă",
];

function InformationHome() {
    return (
        <MKBox component="section" pt={{ xs: 8, md: 10 }} pb={{ xs: 3, md: 5 }}>
            <Container>
                <Grid container item xs={12} lg={10} justifyContent="center" sx={{ mx: "auto" }}>
                    <MKTypography variant="h2" color="dark" mb={3} sx={{ textWrap: "balance" }}>
                        Curățarea profesională a suprafețelor vitrate
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3} sx={{ textWrap: "pretty" }}>
                        Curățarea sticlei și a tâmplăriei este o artă: fiecare suprafață primește
                        atenție specială, iar fiecare metodă de curățare este adaptată în funcție de
                        natura elementelor și a depunerilor aflate pe suprafețe.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3} sx={{ textWrap: "pretty" }}>
                        Pentru o curățare de întreținere a suprafețelor vitrate și a ferestrelor,
                        unde găsim doar murdărie neaderentă, utilizăm dispozitive telescopice,
                        ustensile profesionale standard de curățare prin racletare, soluții
                        profesionale premium și ustensile speciale de finisare a suprafețelor.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3} sx={{ textWrap: "pretty" }}>
                        Pentru curățarea în profunzime și îndepărtarea materialelor aderente naturale
                        sau a celor rămase în urma constructorilor, utilizăm doar produse de curățare
                        specifice categoriei respective, răzuitoare profesionale și dispozitive de
                        îndepărtare a murdăriei care nu afectează sticla și elementele de feronerie.
                    </MKTypography>

                    <MKTypography variant="h3" color="dark" mt={2} mb={2} sx={{ textWrap: "balance" }}>
                        Tratamente speciale
                    </MKTypography>
                    <MKBox component="ul" pl={4} mb={3}>
                        {specialTreatments.map((treatment) => (
                            <MKTypography
                                component="li"
                                key={treatment}
                                variant="body1"
                                color="text"
                                mb={1}
                                sx={{ textWrap: "pretty" }}
                            >
                                {treatment}
                            </MKTypography>
                        ))}
                    </MKBox>

                    <MKTypography variant="body1" color="text" mb={3} sx={{ textWrap: "pretty" }}>
                        Pentru lucrări de curățare în profunzime la peste 3 metri, unde este necesar
                        lucrul manual al operatorilor în contact direct cu suprafețele și utilizarea
                        produselor chimice pentru îndepărtarea materialelor, folosim structuri
                        metalice, platforme electrice, utilaje specializate sau alpiniști utilitari.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" sx={{ textWrap: "pretty" }}>
                        Spălarea finală se poate realiza atât prin jet de apă cu presiune, cât și
                        prin osmoză inversă.
                    </MKTypography>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default InformationHome;
